// Where a number came from, said beside it. The reports have two sources and
// never blend them: Postgres is the truth and always answers; ClickHouse is
// the event warehouse and answers when it can. A figure that names its source
// is one a marketer can check against the right place (slice 5.3).

import { cn } from "@/lib/utils";

const MEANING = {
  Postgres: "Postgres: a küldés, a visszajelzések, a leiratkozás és a rendelések — mindig válaszol",
  ClickHouse: "ClickHouse, az eseménytárház: a nyitás és a kattintás — ha nem válaszol, a szám helyén „nem elérhető” áll",
} as const;

export function SourceMark({ source, className }: { source: keyof typeof MEANING; className?: string }) {
  return (
    <span title={MEANING[source]} className={cn("data-mono text-label text-muted-foreground", className)}>
      {source}
    </span>
  );
}
